module.exports = __webpack_public_path__ + "img/celular.d72013ea.png";